import * as Implementation from "./Implementation/index.js";
import { CommunicationMethod } from "../../../CoStar/Api/EnterpriseSub2/index.js";
/** CoStar.Api.Security.CommunicationMethod */
export { CommunicationMethod };
import { RateBasis } from "../../../CoStar/Api/Analytics/CommonEntities/Enums/index.js";
/** CoStar.Api.Security.RateBasis */
export { RateBasis };
/** CoStar.Api.Security.ReletSpaceName */
export var ReletSpaceName;
(function (ReletSpaceName) {
    ReletSpaceName[ReletSpaceName["None"] = 0] = "None";
    ReletSpaceName[ReletSpaceName["Direct"] = 1] = "Direct";
    ReletSpaceName[ReletSpaceName["Relet"] = 2] = "Relet";
})(ReletSpaceName || (ReletSpaceName = {}));
/** CoStar.Api.Security.AuthenticationStatus */
export var AuthenticationStatus;
(function (AuthenticationStatus) {
    AuthenticationStatus[AuthenticationStatus["SessionOk"] = 0] = "SessionOk";
    AuthenticationStatus[AuthenticationStatus["CompanyOnHold"] = -16] = "CompanyOnHold";
    AuthenticationStatus[AuthenticationStatus["GlobalTimeout"] = -15] = "GlobalTimeout";
    AuthenticationStatus[AuthenticationStatus["ProductSessionTimeout"] = -14] = "ProductSessionTimeout";
    AuthenticationStatus[AuthenticationStatus["NeedSecretQA"] = -13] = "NeedSecretQA";
    AuthenticationStatus[AuthenticationStatus["CertificateRevoked"] = -12] = "CertificateRevoked";
    AuthenticationStatus[AuthenticationStatus["CertificateMissing"] = -11] = "CertificateMissing";
    AuthenticationStatus[AuthenticationStatus["CertificateExpired"] = -10] = "CertificateExpired";
    AuthenticationStatus[AuthenticationStatus["ChangePassword"] = -9] = "ChangePassword";
    AuthenticationStatus[AuthenticationStatus["AccountDisabled"] = -8] = "AccountDisabled";
    AuthenticationStatus[AuthenticationStatus["TooManyViolations"] = -7] = "TooManyViolations";
    AuthenticationStatus[AuthenticationStatus["AccountOnHold"] = -6] = "AccountOnHold";
    AuthenticationStatus[AuthenticationStatus["DuplicateSession"] = -5] = "DuplicateSession";
    AuthenticationStatus[AuthenticationStatus["LockedOut"] = -4] = "LockedOut";
    AuthenticationStatus[AuthenticationStatus["DidNotAuthenticate"] = -3] = "DidNotAuthenticate";
    AuthenticationStatus[AuthenticationStatus["NewSession"] = -2] = "NewSession";
    AuthenticationStatus[AuthenticationStatus["UnknownError"] = -1] = "UnknownError";
})(AuthenticationStatus || (AuthenticationStatus = {}));
/** CoStar.Api.Security.SignInStatus */
export var SignInStatus;
(function (SignInStatus) {
    SignInStatus[SignInStatus["Success"] = 0] = "Success";
    SignInStatus[SignInStatus["InvalidUserNameOrPassword"] = 1] = "InvalidUserNameOrPassword";
    SignInStatus[SignInStatus["InvalidRequest"] = 3] = "InvalidRequest";
    SignInStatus[SignInStatus["InvalidVersion"] = 4] = "InvalidVersion";
    SignInStatus[SignInStatus["ObsoleteVersion"] = 5] = "ObsoleteVersion";
    SignInStatus[SignInStatus["InvalidDevice"] = 6] = "InvalidDevice";
    SignInStatus[SignInStatus["RequiresSecureConnection"] = 7] = "RequiresSecureConnection";
    SignInStatus[SignInStatus["RequiresValidCertificate"] = 8] = "RequiresValidCertificate";
    SignInStatus[SignInStatus["RequiresValidKeyFobNumber"] = 9] = "RequiresValidKeyFobNumber";
    SignInStatus[SignInStatus["NotActivated"] = 10] = "NotActivated";
    SignInStatus[SignInStatus["UnknownError"] = 11] = "UnknownError";
    SignInStatus[SignInStatus["NoProductMarkets"] = 12] = "NoProductMarkets";
    SignInStatus[SignInStatus["DeviceNotAllowed"] = 13] = "DeviceNotAllowed";
    SignInStatus[SignInStatus["AccountDisabled"] = -8] = "AccountDisabled";
    SignInStatus[SignInStatus["AccountOnHold"] = -6] = "AccountOnHold";
    SignInStatus[SignInStatus["LockedOut"] = -4] = "LockedOut";
})(SignInStatus || (SignInStatus = {}));
export { Implementation };
